import { makeBaseSvgIconProps } from './_utils/makeBaseSvgIconProps'

export const IconRepeater = () => {
  return (
    <svg {...makeBaseSvgIconProps('0 0 36 36')}>
      <path d="M0 33.1769363 18.0000166 2 36 33.1769363z" fill="currentColor" />
    </svg>
  )
}
